import { getAPI } from "./axios-base";
import Admin from "@/models/Admin";
import Checker from "@/models/Checker";

export default class RestResourceAuth {
  addAdmin(body: Admin) {
    return getAPI.post("api/rest/v1/auth/add/user", { ...body, role: "Admin" });
  }
  addSeller(body: Admin) {
    return getAPI.post("api/rest/v1/auth/add/user", { ...body, role: "Seller" });
  }
  addClient(body: Admin) {
    return getAPI.post("api/rest/v1/auth/add/user", {
      ...body,
      role: "Client",
      created: true
    });
  }

  addChecker(body: Checker) {
    return getAPI.post("api/rest/v1/auth/add/user", {
      ...body,
      role: "Checker"
    });
  }
}
